import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-800 py-5" data-id="element-4">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full justify-between items-center text-left focus:outline-none group" data-id="element-5">
        <span className="text-lg md:text-xl font-bold text-slate-200 group-hover:text-blue-400 transition-colors pr-4" data-id="element-6">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="flex-shrink-0 bg-slate-800 p-2 rounded-full" data-id="element-7">
          <ChevronDown className="w-5 h-5 text-blue-500" data-id="element-8" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-9">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-10">
            <p className="pt-4 text-slate-400 text-lg leading-relaxed" data-id="element-11">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}